import urbanLayoutResult from '@/assets/img/users-cases/urban-layout.webp';
import urbanLayoutResultHow from '@/assets/img/users-cases/urban-layout-how.webp';
import urbanLayoutResultResult from '@/assets/img/users-cases/urban-layout-result.webp';

export default {
  slug: 'urban-layout',
  order: 28,
  title: '3D Urban Layout',
  subtitle: 'AI-powered generation of large-scale urban residential layouts in 3D environment.',
  tags: ['UrbanPlanning', '3DVisualization'],

  images: {
    hero: urbanLayoutResult,
    aboutTop: urbanLayoutResultHow,
    aboutBottom: urbanLayoutResultResult,
  },

  howText:
    'The master plan for the urban project was uploaded to the AI house plan generator, which created accurate 2D layouts of each building. The system then converted these plans into a complete 3D urban model, including streets, pathways, and public areas, which was used to produce 360° interactive walkthroughs for investors and stakeholders.',

  resultText:
    'By leveraging our floorplan AI, the development team could produce 2D floor plans for all buildings, a complete 3D layout of the residential district, and 360° virtual tours that illustrated building positions, open spaces, and pathways. This comprehensive visualization reduced approval cycles and provided investors with a clear understanding of the urban project before construction.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
